import { render, staticRenderFns } from "./offset.vue?vue&type=template&id=65686c98&scoped=true&"
import script from "./offset.vue?vue&type=script&lang=babel&"
export * from "./offset.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65686c98",
  null
  
)

export default component.exports